<im-accordion class="info-collapse" [class]="'info-collapse--' + type()">
  <ng-container imAccordionItem [opened]="!collapsed()">
    <span *imAccordionHeader class="info-collapse__header">
      <span class="pe-2">
        <span [class]="'icon icon--' + statusIcon()"></span>
      </span>
      <ng-content select="[info-header]"></ng-content>
    </span>
    <div *imAccordionContent class="info-collapse__content">
      <ng-content select="[info-content]"></ng-content>
    </div>
  </ng-container>
</im-accordion>
